var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"image-container"},[_c('img',{attrs:{"src":_vm.src}})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }